import template from './camAudio.html';

/* @ngInject */
function CamAudioController($q, $log, CameraService, growl) {
  const vm = this;

  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //


  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onInit = init;
  vm.saveAudio = saveAudio;
  vm.enableAudioCapturingChanged = enableAudioCapturingChanged;

  function init() {
    _.assign(vm, vm.resolve);

    vm.camera = angular.copy(CameraService.getCamera(vm.panel.id, vm.cameraId));
    vm.camera.audioSettings = null;
    vm.camera.audioAlerts = null;

    $q.all([
      getAudioSettings(vm.camera.id),
      getAudioAlertsSettings(vm.camera.id)
    ])
      .then(([audSettings, audAlerts]) => {
        vm.camera.audioSettings = audSettings;
        vm.camera.audioAlerts = audAlerts;

        vm.loadingSpinners = true;
      })
      .catch((err) => {
        vm.camera.audioSettings = {};
        vm.camera.audioAlerts = {};
        vm.loadingSpinners = true;
        growl.error(err, {
          title: 'Error retrieving audio:'
        });
        $log.error(err);
        return $q.reject();
      });
  }

  function getAudioSettings(id) {
    return CameraService.getAudioSettings(id)
      .then(success => success.data);
  }

  function getAudioAlertsSettings(id) {
    return CameraService.getAudioAlertsSettings(id)
      .then(success => success.data);
  }

  function saveAudio() {
    let growlMessage = growl.info('Saving audio...', {
      disableCloseButton: true
    });
    CameraService.setAudioSettings(vm.camera.id, angular.copy(vm.camera.audioSettings))
      .then(() => {
        if (vm.camera.audioAlerts) {
          return CameraService
            .setAudioDetection(vm.camera.id, angular.copy(vm.camera.audioAlerts));
        }
        return true;
      })
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Audio saved successfully.');
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Error saving audio:'
        });
      });
  }

  function enableAudioCapturingChanged() {
    if (vm.camera.audioSettings.enabled === 'no') {
      vm.camera.audioAlerts.enabled = false;
    }
  }
}

export default {
  name: 'camAudio',
  template,
  controller: CamAudioController,
  controllerAs: 'CamAudioCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&'
  }
};
